import React from 'react'
import SMSPanel from '../SMSPanel/SMSPanel'
import LogsPanel from './LogsPanel'

export default function InformationsTab ({ slot, setLoading, style = {} }) {
  return (
    <div style={{ ...style, display: 'flex', justifyContent: 'space-between' }} >
      <div style={{ width: '47%' }} ><LogsPanel slot={slot} /></div>
      <div style={{ width: '47%' }} ><SMSPanel owner={slot} ownerType="slots" setLoading={setLoading} /></div>
    </div>
  )
}
